module.exports = __webpack_public_path__ + "img/slide_notice_ser.73d91111.svg";